import React, { useEffect, useState } from 'react'
import { Button, DatePicker, Input, Select, Spin, Table } from 'antd'
import 'aos/dist/aos.css'
import '../MainCSS.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi'
import { RackMasterGet } from '../../AllAPI/MasterAPI/ProductionMasterApi'
import { GetRackReleaseReportData } from '../../AllAPI/SalesOrderReportAPI/SalesOrderReportApi'

const RackWiseDetails = () => {


  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

  const [errors, setErrors] = useState({
    rackNo: '',
  })

  const [rackNo, setRackNo] = useState('')
  const [loading, setLoading] = useState(false)

  const [allRackNo, setAllRackNo] = useState([])

  // Fetch RackNo Report Data
  let isRackNoFetched = false
  useEffect(() => {
    if (isRackNoFetched) return
    fetchRackNo()
    isRackNoFetched = true
  }, [])

  // ==============Get table data================

  let isError = false

  const fetchRackNo = async () => {
    try {
      const response = await axios.get(RackMasterGet, commonHeaders1)
      if (response.data !== null) {
        setAllRackNo(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Rack No:', error)
        toast.error('Failed to fetch Rack No data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  //=========CANCEL EMPLOYEE DATA============
  const handleCancel = () => {
    // setAllAgeingReportData([0])
    setRackNo('')
    setErrors('')
  }

  //=========GET RACK RELEASE REPORT DATA============

  const handleShowPdf = async () => {
    let isValid = true
    const errorObj = {}

    if (rackNo) {
      isValid = false
      errorObj.rackNo = 'Rack No. is required *'
    }

    setErrors(errorObj)
    if (!isValid) return

    const url = `${GetRackReleaseReportData}?rackNo=${rackNo}`

    try {
      const response = await axios.get(url, commonHeaders1)

      if (response.data !== null) {
        if (
          response.data === 'NOTFOUND' ||
          response.data === 'NODATA' ||
          response.status === 204
        ) {
          toast.warn('No data available!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setLoading(false)
          return // Exit function early
        }
  
        let reportUrl = response.data
        if (reportUrl === 'NOTFOUND') {
          toast.warn('Report File Not Found...!!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
        } else {
          const reportLink = BaseIPForPDF + `output/${reportUrl}`
          window.open(reportLink, '_blank')
        }
      }
    } catch (error) {
      setLoading(false)
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //==============================================================================

  return (
     <>
          <div className="px-5 py-3">
            <div
              className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
              style={{ backgroundColor: '#e0efff' }}
            >
              
    
              <div className="col-12">
                <div className="row px-md-5 mt-3 p-2">
                    <div className="row p-0 m-0">
                     <div className="col-md-4"></div>
                      <div className="col-md-4 py-1">
                        <label className="labels">Rack No.</label>
                        <Select
                          value={rackNo || undefined}
                          onChange={setRackNo}
                          showSearch
                          className="w-100"
                          placeholder="Select Rack No."
                          optionFilterProp="children"
                        >
                          {allRackNo.map((rack) => (
                            <Option key={rack.id} value={rack.id}>
                              {rack.rackNumber}
                            </Option>
                          ))}
                        </Select>
                        {errors.rackNo && (
                          <div className="errorField">{errors.rackNo}</div>
                        )}
                      </div> 
                      <div className="col-md-4"></div>
                       <div className="col-12 text-center pt-3">
                        <Button
                          type="submit"
                          className="CancelBtn mx-1"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          className="SubmitBtn mx-1"
                          onClick={handleShowPdf}
                        >
                          {loading ? "Generating Pdf..." : "View Report"}
                        </Button>
                        </div>                      
  
    
                  <div
                    className="col-12 p-0 mt-3"
                    style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
                  ></div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </>
  )
}

export default RackWiseDetails